import { createApp } from 'vue'
import App from './App.vue'


import router from './router'
import VueSweetalert2 from 'vue-sweetalert2'
import ElementPlus from 'element-plus'

import 'bootstrap/dist/css/bootstrap.css'
import 'boxicons/css/boxicons.min.css'
import 'element-plus/dist/index.css'
import 'sweetalert2/dist/sweetalert2.min.css';

const app = createApp(App)
app.use(router)
app.use(VueSweetalert2)
app.use(ElementPlus)
app.mount('#app')

// createApp(App).use(router).mount('#app')
